module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_HelpCircle1_16"],"path":[{"$":{"d":"M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM9,13H7V11H9ZM9,8.75V10H7V7.5s3.31.12,3.24-1.62c0-.76-1-1.2-2.06-1.21C7.69,4.67,6.09,4.74,6,6H4c.13-1.77,1.58-3,4.17-3C11.5,3,12,5.12,12,5.75,12,8.56,9,8.75,9,8.75Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_HelpCircle1_16.svg
// module id = YIiX
// module chunks = 1